import { render, staticRenderFns } from "./invDataUpDc.vue?vue&type=template&id=d0463ed2"
import script from "./invDataUpDc.vue?vue&type=script&lang=js"
export * from "./invDataUpDc.vue?vue&type=script&lang=js"
import style0 from "./invDataUpDc.vue?vue&type=style&index=0&id=d0463ed2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports